export const authPageTheme = {
  theme: 'document',
  background: 'gray15',
  '@dark': {
    background: 'gray1+6'
  },
  '@light': {
    background: 'gray15'
  },
  // White-label host (root.whitelabelBrand set — Nika 2026-10-14): the same
  // soft accent light behind the card as the branded sign-in, and its page
  // inset, so signup / reset / accept-invite sit in the same scene as login.
  // Inert on the platform: `style` answers an empty object and `.isBranded`
  // never applies. Inline `style` because the light is mixed from the tenant
  // accent, a record value with no design-system token
  // (functions/whitelabelAuthPaint.js).
  subscribeTo: ['whitelabelBrand'],
  isBranded: (el, s) => !!(s && s.root && s.root.whitelabelBrand),
  style: (el, s) => {
    const paint = el.call('whitelabelAuthPaint', s)
    return paint ? { backgroundImage: paint.backdrop, backgroundRepeat: 'no-repeat' } : {}
  },
  '.isBranded': {
    padding: 'C A'
  }
}
